<div class="login">
  <div class="mfa-container">
    <h1>Authorisation Required</h1>
    <div class="mfa-reason" *ngIf="mfaRequestReason">{{ mfaRequestReason }}</div>

    <div class="mfa-instructions">
      <p>
        An authorisation code has been sent to your email
        <span class="redacted-email">{{ redactedEmail }}</span>
      </p>
      <p class="email-not-recognised">
        (If you don't recognise this email address please contact your manager.)
      </p>
    </div>

    <form (ngSubmit)="onSubmit()" class="mfa-form">
      <label for="mfaCode">Please enter the code below to proceed</label>
      <input
        class="mfa-code"
        type="text"
        id="mfaCode"
        name="mfaCode"
        [(ngModel)]="mfaCode"
        placeholder="______"
        required
      />

      <div class="mfa-device-name">
        <label for="deviceName">Name this device (optional):</label>
        <input
          type="text"
          id="deviceName"
          name="deviceName"
          [(ngModel)]="deviceName"
          placeholder="Work Laptop"
        />
      </div>

      <div class="mfa-trust-device">
        <label>
          <input
            type="checkbox"
            [(ngModel)]="trustDeviceAndLocation"
            name="trustDeviceAndLocation"
          />
          Trust this device and location
          <i
            id="trustDeviceAndLocationTooltip"
            class="fas fa-question-circle"
            ngbTooltip="Only check this box if you are on a device and location you regularly use."
            placement="right"
            tooltipClass="bl-tooltip">
          </i>
        </label>
      </div>

      <div *ngIf="successMessage" class="success-message">
        {{ successMessage }}
      </div>
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <p *ngIf="showRedirect">Redirecting in {{ redirectCountdown }} seconds...</p>
      <button type="submit" [disabled]="!mfaCode">Verify Code</button>
    </form>

    <div class="mfa-request-section">
      <button
        (click)="requestMfaCode()"
        [disabled]="isRequestButtonDisabled"
      >
        Request New Code
      </button>
      <p *ngIf="isRequestButtonDisabled">
        You can request a new code in {{ countdown }} seconds.
      </p>
    </div>
  </div>
</div>